/* eslint-disable @typescript-eslint/no-explicit-any */
// In questo caso è davvero ANY
Array.prototype.sortBy = function <T>(this: T[], fieldProjector: (element: T) => any, direction: 'asc' | 'desc' = 'asc') {
	const sign = direction === 'asc' ? 1 : -1;
	return [...this].sort((a, b) => (fieldProjector(a) - fieldProjector(b)) * sign);
};

export {};
